import { env } from '../config/env'

const ABSOLUTE_URL_REGEX = /^https?:\/\//i

const resolveApiOrigin = (): string | null => {
  const configured = String(env.API_URL || '').trim()
  if (!configured || configured.startsWith('/')) return null

  try {
    const parsed = new URL(configured, window.location.origin)
    return parsed.origin
  } catch {
    return null
  }
}

export const resolveMediaUrl = (value?: string | null): string | null => {
  const raw = String(value || '').trim()
  if (!raw) return null

  if (raw.startsWith('data:') || raw.startsWith('blob:')) return raw
  if (ABSOLUTE_URL_REGEX.test(raw)) return raw
  if (raw.startsWith('//')) return `${window.location.protocol}${raw}`

  if (raw.startsWith('/images/') || raw.startsWith('/media/')) {
    const apiOrigin = resolveApiOrigin()
    return apiOrigin ? `${apiOrigin}${raw}` : raw
  }

  return raw
}
